export default __webpack_public_path__ + "static/media/RW-ArabiaSaudita(360x600).12e43bd3.webp";